/* eslint-disable react/function-component-definition */

import React, { useEffect } from 'react';
import styles from './viewShowAttendee.module.scss';
import AttendeeCustomTable from '../../components/AttendeeCustomTable/CustomTable';

const ViewAttendees = React.memo(() => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.indexdiv}>
      <AttendeeCustomTable />
    </div>
  );
});
export default ViewAttendees;
